import { render, staticRenderFns } from "./CorrectAnswerForm.vue?vue&type=template&id=7fa2879c&scoped=true&"
import script from "./CorrectAnswerForm.vue?vue&type=script&lang=js&"
export * from "./CorrectAnswerForm.vue?vue&type=script&lang=js&"
import style0 from "./CorrectAnswerForm.vue?vue&type=style&index=0&id=7fa2879c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa2879c",
  null
  
)

export default component.exports